/* NewBorn Times : panier lateral. Ajout sans quitter la page, ouverture au clic sur l'icone du panier. */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-nbt-drawer]');
  if (!drawer || drawer.dataset.nbtReady) return;
  drawer.dataset.nbtReady = '1';
  var en = /^en/i.test(document.documentElement.lang || '');
  var T = en
    ? { photo: 'Photo added', remove: 'Remove', qty: 'Qty', err: 'Something went wrong. Please try again.' }
    : { photo: 'Photo ajoutée', remove: 'Retirer', qty: 'Qté', err: "Une erreur s'est produite. Réessayez." };
  var list = drawer.querySelector('[data-nbt-drawer-list]');
  var empty = drawer.querySelector('[data-nbt-drawer-empty]');
  var foot = drawer.querySelector('[data-nbt-drawer-foot]');
  var total = drawer.querySelector('[data-nbt-drawer-total]');
  var ok = drawer.querySelector('[data-nbt-drawer-ok]');

  function money(cents, cur) {
    try { return new Intl.NumberFormat(en ? 'en-US' : 'fr-FR', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function render(cart) {
    list.innerHTML = '';
    cart.items.forEach(function (it) {
      var meta = [];
      if (it.variant_title) meta.push(esc(it.variant_title));
      var props = it.properties || {};
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (!v || k.charAt(0) === '_') return;
        if (/^https?:\/\//.test(v)) { meta.push(esc(T.photo)); return; }
        meta.push(esc(k) + ' : ' + esc(v));
      });
      var li = document.createElement('li');
      li.className = 'nbt-drawer__line';
      li.innerHTML =
        (it.image ? '<img class="nbt-drawer__img" src="' + esc(it.image.replace(/(\.\w+)(\?|$)/, '_160x$1$2')) + '" alt="">' : '<span class="nbt-drawer__img"></span>') +
        '<div><p class="nbt-drawer__name">' + esc(it.product_title) + '</p><p class="nbt-drawer__meta">' + meta.join('<br>') + (it.quantity > 1 ? '<br>' + esc(T.qty) + ' ' + it.quantity : '') + '</p></div>' +
        '<div><div class="nbt-drawer__price">' + money(it.final_line_price, cart.currency) + '</div><button type="button" class="nbt-drawer__remove" data-key="' + esc(it.key) + '">' + esc(T.remove) + '</button></div>';
      list.appendChild(li);
    });
    var has = cart.items.length > 0;
    empty.hidden = has; foot.hidden = !has;
    total.textContent = money(cart.total_price, cart.currency);
    // pastille du nombre d'articles dans l'en-tete
    document.querySelectorAll('.nbt-cart').forEach(function (a) {
      var hide = a.querySelector('.nbt-hide-m');
      if (hide) hide.textContent = hide.textContent.replace(/\(\d+\)/, '(' + cart.item_count + ')');
      var show = a.querySelector('.nbt-show-m');
      if (show) {
        var b = show.querySelector('span');
        if (cart.item_count > 0) {
          if (!b) { b = document.createElement('span'); show.appendChild(b); }
          b.textContent = cart.item_count;
        } else if (b) { b.remove(); }
      }
    });
    return cart;
  }
  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render);
  }
  function open(justAdded) {
    drawer.hidden = false;
    ok.hidden = !justAdded;
    document.body.classList.add('nbt-drawer-open');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('nbt-drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
  }
  drawer.querySelectorAll('[data-nbt-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  list.addEventListener('click', function (e) {
    var b = e.target.closest('.nbt-drawer__remove');
    if (!b) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: 0 }) })
      .then(function (r) { return r.json(); }).then(render);
  });
  // icone du panier : ouvre le panier lateral (le lien vers la page panier reste en secours)
  document.querySelectorAll('.nbt-cart').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(function () { open(false); }); });
  });
  // formulaires de commande : ajout sans recharger la page
  document.querySelectorAll('[data-nbt-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(true); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });
  refresh();
})();
